import { IconContext } from "react-icons";
import { FaMoon } from "react-icons/fa";

export const YellowMoonProvider = () => {
    return (
      <IconContext.Provider
        value={{ color: '#ffd82b', size: '3rem' }}
      >
        <div>
          <FaMoon />
        </div>
      </IconContext.Provider>
    );
  }